import { render, staticRenderFns } from "./StaffPicturePreview.vue?vue&type=template&id=3cbfb601"
import script from "./StaffPicturePreview.vue?vue&type=script&lang=js"
export * from "./StaffPicturePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports